import { useDevAgentStore } from "@/stores/devAgentStore";
import { sseState } from "./sseMutableState";

export const S = () => useDevAgentStore.getState();

export function add(type: string, data: Record<string, any>): void {
  S().addFeedItem({ type: type as any, data });
}

export function upsertThinking(label: string, stepId: string): void {
  if (sseState.activeThinkingId) {
    S().updateFeedItem(sseState.activeThinkingId, { label, stepId });
  } else {
    add("thinking", { label, stepId });
    const items = S().feedItems;
    sseState.activeThinkingId = items[items.length - 1]?.id || null;
  }
}

export function clearThinking(): void {
  if (sseState.activeThinkingId) {
    S().removeFeedItem(sseState.activeThinkingId);
    sseState.activeThinkingId = null;
  }
}

export function updatePlanStep(stepNumber: number, status: string): void {
  const planItem = S().feedItems.find((f) => f.type === "plan");
  if (!planItem) return;
  const steps = [...(planItem.data.steps || [])];
  const idx = steps.findIndex((s: any) => s.step_number === stepNumber);
  if (idx >= 0) steps[idx] = { ...steps[idx], status };
  S().updateFeedItem(planItem.id, { steps });
}
